import React, { useState, useEffect } from "react";
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import { putAPI_Update_Image, putAPI_Delete_Image } from '../../../../../../constants/APIs';
import TagsInput from "react-tagsinput";
import "react-tagsinput/react-tagsinput.css";
import {
    Row,
    Input,
    InputGroup,
    InputGroupAddon,
    InputGroupText,
    Label,
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Alert,
    UncontrolledAlert,
    CustomInput
} from 'reactstrap';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
const Checkmark = ({ selected }) => (
    <div
        style={
            selected
                ? { left: "4px", top: "4px", position: "absolute", zIndex: "1" }
                : { display: "none" }
        }
    >
        <svg
            style={{ fill: "white", position: "absolute" }}
            width="24px"
            height="24px"
        >
            <circle cx="12.5" cy="12.2" r="8.292" />
        </svg>
        <svg
            style={{ fill: "#06befa", position: "absolute" }}
            width="24px"
            height="24px"
        >
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
        </svg>
    </div>
);

const imgStyle = {
    transition: "transform .135s cubic-bezier(0.0,0.0,0.2,1),opacity linear .15s"
};
const selectedImgStyle = {
    transform: "translateZ(0px) scale3d(0.9, 0.9, 1)",
    transition: "transform .135s cubic-bezier(0.0,0.0,0.2,1),opacity linear .15s"
};
const cont = {
    backgroundColor: "#eee",
    cursor: "pointer",
    overflow: "hidden",
    position: "relative"
};

const SelectedJson = ({
    index,
    photo,
    margin,
    direction,
    top,
    left,
    selected,
    ParentImage,
    chosenImage,
    ParentDeleteImage,
    ParentEditImage
}) => {
    const [isSelected, setIsSelected] = useState(selected);
    const [selectedImg, setselectedImg] = useState(chosenImage);
    const [deleteVisible, setDeleteVisible] = useState(false);
    const [imageTags, setimageTags] = useState(photo.tags);
    const [imageCaption, setImageCaption] = useState(photo.caption);
    const [editVisible, seteditVisible] = useState(false);
    //calculate x,y scale
    const sx = (100 - (30 / photo.width) * 100) / 100;
    const sy = (100 - (30 / photo.height) * 100) / 100;
    selectedImgStyle.transform = `translateZ(0px) scale3d(${sx}, ${sy}, 1)`;

    if (direction === "column") {
        cont.position = "absolute";
        cont.left = left;
        cont.top = top;
    }
    const handleTagChange = (event) => {
        setimageTags(event);
    };
    const handleChange = (event) => {
        setImageCaption(event.target.value);
    };
    const handleOnClick = (id, event) => {
        setselectedImg(id)
        ParentImage(id);
        // setIsSelected(!isSelected);
    };
    const toggle = () => {
        setDeleteVisible(!deleteVisible);
    };
    const toggleedit = () => {
        seteditVisible(!editVisible);
    };

    const handleDelete = () => {
        AxiosAPI({
            method: 'put',
            url: `${putAPI_Delete_Image}/${photo.id}`,
            data: {
                deleter: 'dashboard'
            },
        })
            .then(res => {
                toggle();
                ParentDeleteImage(photo.id)
            })
            .catch(err => {
                console.log(err);
            });
    };

    const handleUpdate = () => {
        AxiosAPI({
            method: 'put',
            url: `${putAPI_Update_Image}/${photo.id}`,
            data: {
                deleter: 'dashboard',
                tags: imageTags,
                caption: imageCaption
            },
        })
            .then(res => {
                toggleedit();
                ParentEditImage(photo.id, imageTags)
            })
            .catch(err => {
                console.log(err);
            });
    };

    const generateDeleteButton = () => {
        return (
            <Row>
                <Colxx xs="12" sm="12" md="12" lg="8" className="mb-4">
                    <Row>
                        <Colxx xs="12" sm="3" className="mb-1">
                            <Modal isOpen={deleteVisible} toggle={toggle}>
                                <ModalHeader toggle={toggle}>
                                    <span role="img" aria-label="warning">
                                        ⚠️
                                    </span>
                                    This image will be deleted!
                                </ModalHeader>
                                <ModalBody>
                                    <Button
                                        color="danger"
                                        onClick={() => handleDelete()}
                                        size="xs"
                                    >
                                        Delete
                                    </Button>
                                    <Button
                                        className="ml-2"
                                        color="dark"
                                        outline
                                        size="xs"
                                        onClick={toggle}
                                    >
                                        Cancel
                                    </Button>
                                </ModalBody>
                            </Modal>
                        </Colxx>
                    </Row>
                </Colxx>
            </Row>
        );
    };

    const generateEditButton = () => {
        return (
            <Row>
                <Colxx xs="12" sm="12" md="12" lg="8" className="mb-4">
                    <Row>
                        <Colxx xs="12" sm="3" className="mb-1">
                            <Modal isOpen={editVisible} toggle={toggleedit}>
                                <ModalHeader toggle={toggleedit}>
                                    Edit Search Tags & Caption
                                </ModalHeader>
                                <ModalBody>
                                    <Row className="mb-4">
                                        <Colxx xxs="12">
                                            <TagsInput
                                                value={imageTags}
                                                onChange={event => handleTagChange(event)}
                                            />
                                        </Colxx>
                                    </Row>
                                    <Row className="mb-4">
                                        <Colxx xxs="12">
                                            <Input
                                                type="text"
                                                name="caption"
                                                placeHolder="Caption"
                                                value={imageCaption}
                                                onChange={event => handleChange(event)}
                                            />
                                        </Colxx>
                                    </Row>
                                </ModalBody>
                                <ModalFooter>
                                    <Button
                                        color="secondary"
                                        onClick={() => handleUpdate()}
                                        size="xs"
                                    >
                                        Update
                                    </Button>
                                    <Button
                                        className="ml-2"
                                        color="dark"
                                        outline
                                        size="xs"
                                        onClick={toggleedit}
                                    >
                                        Cancel
                                    </Button>
                                </ModalFooter>
                            </Modal>
                        </Colxx>
                    </Row>
                </Colxx>
            </Row>
        );
    };

    useEffect(() => {
        setIsSelected(selected);
    }, [selected]);

    return (
        <div
            style={{ margin, position: 'relative', height: photo.height, width: photo.width, ...cont }}
            className={chosenImage !== photo.id ? "not-selected" : "img-selected"}
        >
            <Checkmark selected={chosenImage == photo.id ? true : false} />
            <img
                alt={photo.caption}
                style={
                    chosenImage == photo.id ? { ...imgStyle, ...selectedImgStyle } : { ...imgStyle }
                }
                {...photo}
                onClick={event => handleOnClick(photo.id, event)}
            />
            <a href="#/" className="edit"
                onClick={toggleedit}
            >
                {" "}
                <i className="glyph-icon simple-icon-pencil" />{" "}
            </a>
            <a href="#/" className="remove"
                onClick={toggle}
            >
                {" "}
                <i className="glyph-icon simple-icon-trash" />{" "}
            </a>
            <style>{`.not-selected:hover{outline:2px solid #06befa}`}</style>
            {generateDeleteButton()}
            {generateEditButton()}
            <span
                className={`badge badge-pill badge-primary
                   position-absolute badge-top-left-2`}
            >
                {photo.caption}
            </span>
        </div>
    );
};

export default SelectedJson;
